import { Component, Input, HostBinding } from '@angular/core';

export interface CardTemplateConfig {
  title: string;
  subtitle?: string;
  showSubtitle?: boolean;
  cardClass?: string;
  titleClass?: string;
  subtitleClass?: string;
  compact?: boolean;
}

@Component({
  selector: 'app-card-template',
  templateUrl: './card-template.component.html',
  styleUrls: ['./card-template.component.scss']
})
export class CardTemplateComponent {
  @Input() config: CardTemplateConfig;
  @Input() cardClass: string = '';
  @Input() title: string = '';
  @Input() subtitle: string = '';
  @Input() showSubtitle: boolean = false;
  @Input() compact: boolean = false;

  @HostBinding('class.compact') get isCompact(): boolean {
    return this.cardConfig.compact;
  }

  @HostBinding('class.video-card') get isVideoCard(): boolean {
    return this.cardConfig.cardClass === 'video-card';
  }

  @HostBinding('class.fill-card') get isFillCard(): boolean {
    return (this.cardConfig.cardClass ?? '').split(' ').includes('fill-card');
  }

  get cardConfig(): CardTemplateConfig {
    return {
      title: this.config?.title || this.title,
      subtitle: this.config?.subtitle || this.subtitle,
      showSubtitle: this.config?.showSubtitle ?? this.showSubtitle,
      cardClass: this.config?.cardClass || this.cardClass,
      titleClass: this.config?.titleClass || '',
      subtitleClass: this.config?.subtitleClass || '',
      compact: this.config?.compact ?? this.compact
    };
  }
}
